export default "__VITE_ASSET__CSxqSCfk__"